import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import QuotationList from '../../components/Entity/Quotation/List/List';
  
const QuotationPage = () => {
  return <Layout fullwidth={0}>
   
      <QuotationList></QuotationList>
     
  </Layout>;
}

export default QuotationPage;